//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
SPLM.CAM.IntStatusData = class{
    constructor(value,inheritance){
        this.value=value;this.inheritance=inheritance;}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Inheritance(){return this.inheritance}
    set Inheritance(val){this.inheritance = val}
};

SPLM.CAM.DoubleStatusData = class{
    constructor(value,inheritance){
        this.value=value;this.inheritance=inheritance;}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Inheritance(){return this.inheritance}
    set Inheritance(val){this.inheritance = val}
};

SPLM.CAM.FeedStatusData = class{
    constructor(value,unit,inheritance){
        this.value=value;this.unit=unit;this.inheritance=inheritance;}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Inheritance(){return this.inheritance}
    set Inheritance(val){this.inheritance = val}
};

SPLM.CAM.DoubleIntentData = class{
    constructor(value,intent,inheritance){
        this.value=value;this.intent=intent;this.inheritance=inheritance;}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Intent(){return this.intent}
    set Intent(val){this.intent = val}
    get Inheritance(){return this.inheritance}
    set Inheritance(val){this.inheritance = val}
};

SPLM.CAM.Inheritance = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

SPLM.CAM.ParamValueIntent = Object.freeze({
    "PartUnits" : "PartUnits", "ToolDep" : "ToolDep", "Function" : "Function", "ToolFluteLength" : "ToolFluteLength", "LengthPercent" : "LengthPercent"});

SPLM.CAM.FeedRateUnit = Object.freeze({
    "None" : "None", "PerMinute" : "PerMinute", "PerRevolution" : "PerRevolution", "Rapid" : "Rapid", "CutPercent" : "CutPercent"});

SPLM.CAM.FeedRapidOutputMode = Object.freeze({
    "G0" : "G0", "G1" : "G1"});

SPLM.CAM.LengthIntent = Object.freeze({
    "PartUnits" : "PartUnits", "Percent" : "Percent"});

SPLM.CAM.ValueIntent = Object.freeze({
    "PartUnits" : "PartUnits", "Function" : "Function"});

export default SPLM;